import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Footer/sgds-footer-item";
import { register } from "../../utils/ce-registry";

register("sgds-footer-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-footer-item",
  elementClass: Component,
  events: {}
});
